import React from 'react';
import { TrendingUp, Building, UserMinus } from 'lucide-react';
const benefits = [{
  title: 'They are 50% Less Likely to Go Out of Business',
  description: "Companies that work with a PEO are 50% less likely to go out of business each year compared to similar businesses that don't.",
  icon: Building,
  stat: '50%'
}, {
  title: 'They Grow Twice as Fast',
  description: "Businesses that partner with a PEO grow their workforce more than twice as fast as those that don't.",
  icon: TrendingUp,
  stat: '2x'
}, {
  title: 'Their Employee Turnover is 12% Lower',
  description: "Businesses that use a PEO experience 12% lower employee turnover than those that don't.",
  icon: UserMinus,
  stat: '12%'
}];
export function BenefitsSection() {
  return <section className="py-16 bg-white" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="text-center mb-16" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-bold text-navy" data-id="element-21">
            3 Ways Small Businesses Benefit From Using A PEO
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-22">
          {benefits.map((benefit, index) => <div key={index} className="bg-gray-50 rounded-xl p-8 border border-gray-100 relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-23">
              <div className="absolute -right-6 -top-6 text-orange opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-24">
                <benefit.icon className="w-32 h-32" data-id="element-25" />
              </div>
              <div className="text-4xl font-extrabold text-orange mb-4" data-id="element-26">
                {benefit.stat}
              </div>
              <h3 className="text-xl font-bold text-navy mb-3 pr-8" data-id="element-27">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-3" data-id="element-28">
                {benefit.description}
              </p>
              <a href="https://napeo.org/intro-to-peos/faqs/" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-orange hover:text-orange-hover underline underline-offset-2 transition-colors" data-id="element-29">
                Source: NAPEO, 2025
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}